import { SearchLocation } from 'src/reducers/Input/types';

// checks for any falsey values in an object
export const hasValidData = (obj: SearchLocation) =>
  obj.state !== 'Select A State' && Object.values(obj).some(elm => elm !== '' || elm !== null);

export const hasValidZipcode = (zip: string) => /^[0-9]{5}(-[0-9]{4})?$/.test(zip);

export const states = {
  names: [
    'AK',
    'AL',
    'AR',
    'AS',
    'AZ',
    'CA',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'FM',
    'GA',
    'GU',
    'HI',
    'IA',
    'ID',
    'IL',
    'IN',
    'KS',
    'KY',
    'LA',
    'MA',
    'MD',
    'ME',
    'MH',
    'MI',
    'MN',
    'MO',
    'MP',
    'MS',
    'MT',
    'NC',
    'ND',
    'NE',
    'NH',
    'NM',
    'NJ',
    'NV',
    'NY',
    'OH',
    'OK',
    'OR',
    'PA',
    'PR',
    'PW',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VA',
    'VI',
    'VT',
    'WA',
    'WI',
    'WV',
    'WY',
  ],
};
